module.exports = __webpack_public_path__ + "static/media/lidingshan_package.619f7fc6.webp";